import { Component, Output, OnInit, EventEmitter, Input, ViewChild, OnChanges} from '@angular/core';
import { UserService } from '../../../providers/user.service';
import { DeviceService } from '../../../providers/device.service';
import { CustomerService } from 'src/app/providers/customer.service';
import { ApplicationService } from 'src/app/providers/application.service';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, map, filter, catchError, tap, finalize } from 'rxjs/operators';
import { Observable, of, OperatorFunction, Subscription, concat, Subject, BehaviorSubject } from 'rxjs';
import { AssetService } from 'src/app/providers/asset.service';
import { BatchService } from 'src/app/providers/batch.service';
import { DevicealertService } from 'src/app/providers/devicealert.service';
import { DownloadlogService } from 'src/app/providers/downloadlog.service';
import { TransactionService } from 'src/app/providers/transaction.service';
import { ConsumerManagementService } from 'src/app/providers/consumer-management.service';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { MerchantService } from 'src/app/providers/merchant.service';
import { NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { DropdownPosition } from '@ng-select/ng-select';
import { isEmpty, trim } from 'lodash';
enum FilterType {
  SEARCH = 'SEARCH',
  DEFAULT = 'DEFAULT',
  LOAD_ALL = 'LOAD_ALL'
}
enum PayloadAction {
  LOAD_ALL = 'loadAllList',
  LOAD_PAGINATE = 'loadPaginateList',
  SEARCH = 'search'
}


@Component({
  selector: 'app-search-box-filter',
  templateUrl: './search-box-filter.component.html',
  styleUrls: ['./search-box-filter.component.scss'],
  providers: [NgbTypeaheadConfig]
})
export class SearchBoxFilterComponent implements OnInit, OnChanges  {
  @Input() apiNameProperty: string;
  @Input() searchByTpnModel: string;
  @Input() searchByStoreModel: string;
  @Input() queryParam:any;
  @Input() placeholder: string;
  @Input() initialDate: any;
  @Input() finalDate: any;
  @Input() customerView: any;
  @Input() filterName: any;
  @Input() clear: any;
  @Input() value: any = null
  @Input() isBackButton = false
  @Output() filteredData = new EventEmitter<any>();
  @Output() apiStatus = new EventEmitter<any>();
  @Output() stores = new EventEmitter<any>();
  @Output() tpnNumber = new EventEmitter<any>();
  @Output() checkSearchBarValue = new EventEmitter<any>();
  @ViewChild('instance', { static: true }) instance: NgbTypeahead;
  @Output() filteredTpn = new EventEmitter<any>();
  @Input() isTpnLabel: boolean = false;
  @Input() isStyleFlag: boolean = false;
  @Input() isDisableEmitTpn: boolean = false;
  @Input() enableSingleSelect: boolean = false;
  @Input() showDeletedTpns: boolean = false; 
  @Input() isShowSuspendedTpns: boolean = false; 
  @Input() filterByBuildNumber: boolean = false;
  @Input() isNonGatewayTpn=false;
  @Input() isLazySelectBox: boolean = false;
  @Input() enableVirtualScroll: boolean = true;
  @Input() notFoundText: string;
  @Input() typeToSearchText: string;
  @Input() dropdownPosition: DropdownPosition = 'bottom';
  @Output() filteredSelect = new EventEmitter<any>();
  @Input() pageSize = 10;
  @Input() bindLabel: string = 'name';
  @Input() bindValue: string = 'id';
  selectList$ = new BehaviorSubject<any[]>([]);
  selectInput$ = new Subject<string>();
  searchedselect = new UntypedFormControl();
  // If true on the initial load, populate the dropdown list with some items.
  @Input() hasDefaultList: boolean = false;
  @Input() localData: any[] = [];
    isLocalOnly(): boolean {
      return this.apiNameProperty === 'thirdPartyApps';
    }
  //state object
  state = {
    currentPage: 1,
    totalselectItemCount: 0,
    currentSelectFilterType: FilterType.DEFAULT, 
    selectListCache: [] as any[],
    selectLoading: false,
    hasSelectBoxLoadedOnce: false,
    previousPage: 1,
    previousTotalCount: 0,
    previousList: [] as any[],
    hasSearchSnapshot: false,
    previousFilterType: FilterType.DEFAULT,
    isLoadAllItems: false,
    lastSearchTerm: '',
    isSelectAllItems: false,
    showNotFound: false,
    globalSelectedItems: [] as any[],
    visibleSelectList: [] as  any[]
  };
  private selectSearchSub?: Subscription;
  filterType = FilterType;
  

  // @Input() enteredStoreValue: string;


  showDefaultLabel$: Observable<any[]>;
  inputTpn$ = new Subject<string>();
  tpnLoading: boolean;
  isSelectAllTpn: boolean = false;
  totalTpns: any;
  enteredstoreDba = '';
  //
 
  //
  
  model: any='';
  //searchByTpnModel: any='';
  searchByTpnModelPrevious: any;
  //searchByStoreModel:any='';
  modelPrevious: any;
  getSearchTerm: any = [];
  tpnResult = [];
  dbaResult = [];
  dbaList = [];
  tpnList = [];
  dbaWithStoreId = [];
  searching:any;
  searchFailed:any;
  searchValue: any;
  searchAboveFourInputs=['currentBuildNumber'];
  private eventsSubscription: Subscription;
  private storeDbaClearSubscription: Subscription;
  private tpnClearSubscription: Subscription;
  private enteredStoreValuerSubscription: Subscription;

  @Input() events: Observable<void>;
  @Input() storeDbaClearEvent: Observable<void>;
  @Input() tpnClearEvent: Observable<void>;
  @Input() enteredStoreValue: Observable<void>;
  @Input() searchedStoreId = [];
  @Input() hideSelected = true;
  @Input() storeId: any;
  @Input() isDisable: boolean = false;
  @Input() useLocalDataOnly: boolean = false;

  
  constructor(private userService: UserService, private deviceService:DeviceService, private customerService: CustomerService, private assetService: AssetService,
              private batchService: BatchService, private applicationService: ApplicationService, private devicealertService: DevicealertService, private downloadLogService: DownloadlogService, private transactionService: TransactionService,
              private consumerManagementService: ConsumerManagementService,
    public commonService: CommonService, private merchantService: MerchantService) {

  }

  sendAPI={
    user:(data)=>{
      return this.userService.getAllUsersByUserId(data);
    },
    device: (data) => {
      return this.deviceService.getAllDevice(data)
    },
    customer:(data)=>{      
      return this.customerService.getAllCustomersByCustomerId(data);
    },
    asset: (data) => {
      return this.assetService.getAllAsset(data);
    },
    application: (data) => {
      return this.applicationService.getAllApplicationData(data);
    },
    batches: (data) => {
      if(data.status == 'close'){
        data.fromDate = this.initialDate;
        data.toDate = this.finalDate;
      }
      return this.batchService.getAllStores(data);
    },
    deviceAlert: (data) => {
      return this.devicealertService.getAllDeviceAlert(data);
    },
    downloadLog : (data) => {
      return this.downloadLogService.getAllDownloadLog(data);
    },
    transaction: (data) => {
      return this.transactionService.getAllTransactions(data);
    },
    consumer: (data) => {
      return this.consumerManagementService.getAllConsumersList(data);
    },
    invoice: (data) => {
      return this.commonService.postCommonHttpClient(apiLinks.getInvoiceV2, data);
    },
    merchant: (data) => {
      return this.merchantService.getAllMerchant(data);
    },
    tickets: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.getAlltickets, data);
    },
    auditLogs: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.getAllAuditLogs, data);
    },
    invoiceList: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.getAllBillingInvoice, data);
    },
    recurringPayments: (data) => {
      return this.commonService.postCommonHttpClient(apiLinks.getRecurringPaymentsList, data);
    },

    proxyLoginLogs: (data) => {
      return this.commonService.postCommonHttpClient(apiLinks.getAllProxyLoginLogs, data);
    },

    promotions: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.getAllPromotions, data);

    },
    inventory: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.inventoryItems(this.storeId), data);

    },
    marketApp: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.marketApp.getAllApps, data);

    },
    getAllValueAddedApps: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.getAllDvStoreThirdPartyApp, data);

    },
    isvNames: (data) => {
      return this.commonService.getCommonHttpClientQueryParams(apiLinks.isvNames, data);

    }
    
  }
  searchFilter = new UntypedFormControl(this.value);
  searchBuildNumber = new UntypedFormControl();
  searchFilter$: Observable<any>[];
  searchedTpn = new UntypedFormControl();

  ngOnInit(clear = false): void {

    this.searchBuildNumber.valueChanges.pipe(
      filter(res => {
        let searchLength=0;
        return trim(res).length > searchLength || trim(res).length==0
      }),

      debounceTime(500),
      distinctUntilChanged(),
      switchMap((val) =>{
        this.apiStatus.emit({isLoading:true});
        
        let searchTerm = trim(val);
          console.log("queryParam buildnum string: ", this.queryParam);
          if(this.searchFilter.value){
            this.queryParam['queryString']= this.searchFilter.value;
          }
          this.queryParam['buildNum']= searchTerm;
          let size=this.apiNameProperty=='marketApp'?3:20;
          let data={ isFilter: true, page:1, size,...this.queryParam, filterByBuildNumber: this.filterByBuildNumber };
          return this.sendAPI[this.apiNameProperty](data);

        })
    )
    .subscribe(data => {
      console.log("searching finished");
      this.apiStatus.emit({isLoading:false});
      console.log(data, this.searchFilter.value);
      if(!data) {
        console.log('empty');
        return false;
      }

      this.filteredData.emit({data, searchTerm: this.searchFilter.value,searchTermName:this.filterName?this.filterName:"queryString", ...(this.searchBuildNumber.value != null && {buildNum: this.searchBuildNumber.value})});
      console.log('after emit');
    },(err) => {

      this.apiStatus.emit({isLoading:false});

   });
    this.searchFilter.valueChanges.pipe(
      filter(res => {
        let searchLength=0;
        if(this.searchAboveFourInputs.indexOf(this.filterName)!=-1){
          searchLength=4;
        }
        console.log(trim(res).length); 
        return trim(res).length > searchLength || trim(res).length==0
      }),

      // if its a back button search we don't want to fetch the data initially hence disabling to 
      // avoid unnecessary requests !
      filter(res => {
        return !this.isBackButton
      }),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((val) =>{
        // console.log('searchTerm---------------');
        console.log('inside filter', val)

        this.apiStatus.emit({isLoading:true});
        
        let searchTerm = trim(val);
          // if(val.length == 0) {
          //   console.log('length 0---------------');
           
          //   return of({})
          // } else if(searchTerm.length == 0) {
          //   console.log('searchTerm 0---------------');
            
          //   return of(false)
          // } else {  
            //console.log(this.queryParam);   

          //   this.queryParam['queryString']= searchTerm;
          //   let data={ isFilter: true, page:1, size:20,...this.queryParam };
          //   return this.sendAPI[this.apiNameProperty](data);
          // }
        console.log("queryParam string: ", this.queryParam, this.searchFilter.value);
          // if(!isUndefined(this.queryParam)) {
            // console.log("I am coming to assign query param");
            
            if(this.filterName){
              if(this.filterName=='amount' && searchTerm!='') {
                this.queryParam[this.filterName]= (Math.round(parseFloat(searchTerm)*100)).toString();
              }else{
                this.queryParam[this.filterName]= searchTerm;
              }
              
            }else{
              this.queryParam['queryString']= searchTerm;
            }
            // search by build num download logs
            if(this.queryParam?.enableBuildNumber && this.queryParam?.enableBuildNumber == true) {
              if(this.searchBuildNumber.value) {
                this.queryParam['buildNum'] = this.searchBuildNumber.value;
              }
            }
          // }
          this.queryParam['queryString'] = this.queryParam['queryString'] ? encodeURIComponent(this.queryParam['queryString']) : this.queryParam['queryString'];
          let size=this.apiNameProperty=='marketApp'?3:20;
          let data={ page:1, size,...this.queryParam, filterByBuildNumber: this.filterByBuildNumber, isFilter: true };
          return this.sendAPI[this.apiNameProperty](data);

        })
    )
    .subscribe(data => {
      console.log("searching finished");
      this.apiStatus.emit({isLoading:false});
      console.log(data, this.searchFilter.value);
      if(!data) {
        console.log('empty');
        return false;
      }

      this.filteredData.emit({data, searchTerm: this.searchFilter.value,searchTermName:this.filterName?this.filterName:"queryString",...(this.searchBuildNumber.value != null && {buildNum: this.searchBuildNumber.value})});
    },(err) => {

      this.apiStatus.emit({isLoading:false});

   });
   if(this.events){
     this.eventsSubscription = this.events.subscribe(() => {
        /* RESET SELECT STATE FIRST */
       this.state.lastSearchTerm = '';
       this.state.currentSelectFilterType = FilterType.DEFAULT;
       this.state.currentPage = 1;
       this.state.totalselectItemCount = 0;
       this.state.selectListCache = [];
       this.state.previousList = [];
       this.state.globalSelectedItems = [];
       this.state.previousPage = 1;
       this.state.previousTotalCount = 0;
       this.state.hasSearchSnapshot = false;
       this.state.isLoadAllItems = false;
       this.state.selectLoading = false;
       this.state.isSelectAllItems = false;
       this.state.hasSelectBoxLoadedOnce = false;
       this.selectList$.next([]);
       this.searchFilter = new UntypedFormControl();
       this.searchBuildNumber = new UntypedFormControl();
       this.searchedTpn = new UntypedFormControl();
       this.searchedselect = new UntypedFormControl();
       this.ngOnInit(true);
       this.eventsSubscription.unsubscribe();
     });

     this.filteredData.emit({ data: null, searchTerm: this.value ? this.value : this.searchFilter.value, searchTermName: this.filterName ? this.filterName : "queryString" });
  }

  if(this.storeDbaClearEvent){
    this.storeDbaClearSubscription = this.storeDbaClearEvent.subscribe((item:any) => {
      if(item){
        this.searchByStoreModel='';
      }
    });
  }

  if(this.tpnClearEvent){
    this.tpnClearSubscription = this.tpnClearEvent.subscribe((item:any) => {
      if(item){
        this.searchedTpn.setValue(null, { emitEvent: false });
      }
  })
    
  }

  


  if(this.enteredStoreValue){
    this.enteredStoreValuerSubscription = this.enteredStoreValue.subscribe((item:any) => {
      
      this.enteredstoreDba = item;

      console.log('this.enteredstoreDba----->',this.enteredstoreDba);
    });
  }

  this.loadTpnLabel();
  this.searchedTpn.valueChanges.subscribe(data => {
    this.filteredTpn.emit(data);
  });
  this.searchedselect.valueChanges.subscribe(data => {
    if (data) {
      this.filteredSelect.emit(data);
    }
  });
  if (this.isLazySelectBox && !this.useLocalDataOnly) {
     // calling initISearchListener only if it isLazySelectBox
     this.initISearchListener();
  } 
   if (this.useLocalDataOnly && this.localData?.length) {
    this.initLocalOnlyMode();
  }
  
  if (!clear) {
      this.searchFilter.setValue(this.value, { emitEvent: false });
      this.searchedTpn.setValue(this.value, {emitEvent: !this.isDisableEmitTpn});
      this.searchedselect.setValue(this.value, { emitEvent: false });
    }
  //  this.eventsSubscription.unsubscribe();
  }

  ngOnDestroy() {

    if(this.events){
      this.eventsSubscription.unsubscribe();
    }
    if(this.storeDbaClearEvent){
      this.storeDbaClearSubscription.unsubscribe();
    }
    if(this.tpnClearEvent){
      this.tpnClearSubscription.unsubscribe();
    }
    if(this.enteredStoreValue){
      this.enteredStoreValuerSubscription.unsubscribe();
    }

    this.selectSearchSub?.unsubscribe();

  }

  ngOnChanges(changes) {    
    if (changes['isDisable']) {
      this.isDisable ? this.searchedTpn?.disable() : this.searchedTpn?.enable();
    }

    if (this.useLocalDataOnly &&changes['localData'] &&this.localData?.length ) {
      this.state.selectListCache = [...this.localData];
      this.selectList$.next([...this.localData]);
    }
        
    //console.log("curr",changes.searchByTpnModel.currentValue);
    // You can also use categoryId.previousValue and 
    // categoryId.firstChange for comparing old and new values
    
  }

  initLocalOnlyMode() {
    this.state.selectListCache = [...this.localData];
    this.state.visibleSelectList = [...this.localData];
    this.selectList$.next([...this.localData]);
    this.selectInput$.pipe(
      debounceTime(300),
      distinctUntilChanged()).subscribe(term => { this.filterLocalData(term) });
  }


  private filterLocalData(term: string): void {
    if (!term) {
      this.state.visibleSelectList = [...this.state.selectListCache];
      this.selectList$.next(this.state.visibleSelectList);
      return;
    }
    const lower = term.toLowerCase();
    const filtered = this.state.selectListCache.filter(item =>
      String(item[this.bindLabel])
        .toLowerCase()
        .includes(lower)
    );

    // ✅ keep visible list in sync
    this.state.visibleSelectList = filtered;
    this.selectList$.next(filtered);
  }

  // selectTpn(item: any) {  
  //   console.log('item', item);  
  //   item.preventDefault();
  //   this.searching = false;
  //   this.searchByTpnModel= item.item.tpn;
  //   this.searchByStoreModel = '';    
  //   //this.searchByTpnModel = item.item;
  //  // this.searchByTpnModelPrevious = this.searchByTpnModel;
  //   this.tpnNumber.emit(item.item.tpn);
    
  // }

  selectDba(item: any){

    item.preventDefault();
    // console.log(item.id);
    this.searching = false;
    this.searchByStoreModel = item.item.dba;
    // this.searchByTpnModel='';
    this.stores.emit(item.item);
    
   // return;
    // 
    // this.modelPrevious = this.model;
    // var result = this.dbaWithStoreId.filter(function(findStore){
    //   if(findStore[0] == item.item) {
    //     return findStore[1];
    //   }
    // });
    // result.forEach(element => {
    //   this.storeId = element[1];
    // });
    
    //console.log('storeId', this.storeId);
  }

  formatter = (result: string) => result.toUpperCase();

  storeFormatter = (x: any) => x.dba;
  tpnFormatter = (x: any) => x.tpn;

  // search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     map(term => term === '' ? []
  //       : this.dbaList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  //   )

  searchStore: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    tap(() => this.searching = true),
    switchMap(term =>
      this.commonService.getResponseDataForFilter(apiLinks.storeDbas, {queryString: term,isFilter:true,page:1,size:10, filterByBuildNumber: this.filterByBuildNumber}).pipe(
        tap((item) => {
          console.log(item);
          this.searchFailed = false;
          this.searching = false;
        }),
        catchError(() => {
          this.searching = false;
          this.searchFailed = true;
          return of([]);
        }))
    ),
    tap(() => this.searching = false)
  )

  searchTpn: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    tap(() => this.searching = true),
    switchMap(term =>
      this.commonService.getResponseDataForFilter(apiLinks.tpnIds, {query: term,isFilter:true,page:1,size:5, filterByBuildNumber: this.filterByBuildNumber}).pipe(
        tap((item) => {
          console.log(item);
          this.searching = false;
          this.searchFailed = false
        }),
        catchError(() => {
          this.searching = false;
          this.searchFailed = true;
          return of([]);
        }))
    ),
    tap(() => this.searching = false)
  )
    // searchForTpn: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    // text$.pipe(
    //   debounceTime(200),
    //   distinctUntilChanged(),
    //   map(term => term === '' ? []
    //     : this.tpnList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    // )

    getSearchKey($event){
      this.searchValue = $event;
      isEmpty($event) ? this.searching = false: '';
      this.checkSearchBarValue.emit($event);
    }

    stopLoader(){
      isEmpty(this.searchValue) || (isEmpty(this.searchByStoreModel) || isEmpty(this.searchByTpnModel))? this.searching = false: '';
    }
    
    loadTpnLabel() {
      const dropdownLatest$ = this.inputTpn$.pipe(
        debounceTime(400),
        tap(() => (this.tpnLoading = true)),
        switchMap((term) => {
          if (term == null || term.trim().length < 3) {
            this.isSelectAllTpn = true;
            this.tpnLoading = false;
            return of([]);
          }
          return this.getAllTpns(term.trim()).pipe(
            map((res) => {
              this.isSelectAllTpn = false;
              this.totalTpns = res.data;
              return res.data;
            }),
            catchError(() => of([])),
            tap(() => (this.tpnLoading = false))
          );
        })
      );

      this.showDefaultLabel$ = concat(of([]), dropdownLatest$);
    }

    getAllTpns(term: string = '') {
      let URL = !this.isNonGatewayTpn?apiLinks.tpnIds:apiLinks.getAllNonGatewayTPN;
      return this.commonService.getCommonHttpClientQueryParams(URL, { isFilter: true, tpnDefaultLabel: term ? term : '', storeDba: this.enteredstoreDba ? this.enteredstoreDba : "", isShowDeactivedTpns: this.showDeletedTpns, isShowSuspendedTpns: this.isShowSuspendedTpns, searchedStore: this.searchedStoreId ? this.searchedStoreId : "", filterByBuildNumber: this.filterByBuildNumber});
    }
    selectAll() {
      this.searchedTpn.patchValue(this.totalTpns.map(data => data.tpn));
    }
  
    unselectAll() {
      this.searchedTpn.patchValue([]);
    }

  selectAllItems() {
    const source = this.state.visibleSelectList.length ? this.state.visibleSelectList : this.state.selectListCache;
    const newValues = source.map(i => this.getModelValue(i));
    const previousValues = this.state.globalSelectedItems.map(i => this.getModelValue(i));
    const mergedValues = [...new Set([...previousValues, ...newValues])]; // merge without duplicates
    this.state.globalSelectedItems = mergedValues;
    this.searchedselect.patchValue(
      this.enableSingleSelect
        ? mergedValues[0] || null
        : mergedValues
    );
    this.state.isSelectAllItems = true;
  }

  unselectAllitems() {
    this.searchedselect.patchValue(this.enableSingleSelect ? null : []);
    this.state.globalSelectedItems = [];
    this.state.isSelectAllItems = false;
  }

  // Load n number of items.
  loadSelectItems(loadMore: boolean) {
    let payload = this.buildPayload(loadMore)
    this.state.selectLoading = true;
    this.fetchRemoteData(payload)
        .subscribe((data: any[]) => {
          this.updateSelectList(data, loadMore);
        });
  }

  private getDynamicSearchKey(): string {
    const keyMap: Record<string, string> = {
      isvNames: 'isvName',
      asset: 'serialSearchTerm'
    };
    return keyMap[this.apiNameProperty] || 'searchKey';
  }

  // To generate the payload.
  private buildPayload(loadMore = false): any {
    const searchKey = this.getDynamicSearchKey();
    const payload: any = {};
    const action = this.getPayloadAction();

    if (this.apiNameProperty === 'isvNames') {
      switch (action) {

        case PayloadAction.LOAD_ALL:
          if (this.state.lastSearchTerm) {
            payload[searchKey] = this.state.lastSearchTerm;
          }
          payload.loadAll = true;
          break;

        case PayloadAction.LOAD_PAGINATE:
          payload.filterType = loadMore ? 'PAGINATE' : 'DEFAULT';
          payload.page = this.state.currentPage;
          payload.size = this.pageSize;
          break;

        case PayloadAction.SEARCH:
          payload.filterType = loadMore ? 'PAGINATE' : 'DEFAULT';
          if (this.state.lastSearchTerm) {
            payload[searchKey] = this.state.lastSearchTerm;
          }
          payload.page = this.state.currentPage;
          payload.size = this.pageSize;
          break;
      }
    } else if (this.apiNameProperty === 'asset') {
      payload.onlySerialNumbers = true;
      if (this.state.lastSearchTerm) {
        payload[searchKey] = this.state.lastSearchTerm;
      }
    }
    return payload;
  }

  // To get the current payload action.
  private getPayloadAction(): PayloadAction {
    if (this.state.currentSelectFilterType === FilterType.LOAD_ALL) {
      return PayloadAction.LOAD_ALL;
    }
    if (this.state.currentSelectFilterType === FilterType.SEARCH) {
      return PayloadAction.SEARCH;
    }
    return PayloadAction.LOAD_PAGINATE;
  }

  private getLocalFilteredData(term: string): any[] {
    const filtered = this.state.previousList.filter((item: any) =>
      this.getSearchValue(item).toLowerCase().includes(term.toLowerCase())
    );
    this.state.totalselectItemCount = filtered.length;
    this.state.selectLoading = false;
    // first page only
    return filtered.slice(0, this.pageSize);
  }

  // To update the select list when loading more items.
  private updateSelectList(data: any[], append: boolean): void {

    const selectedValues = this.enableSingleSelect
      ? (this.searchedselect.value ? [this.searchedselect.value] : [])
      : (this.searchedselect.value || []);

    const selectedSet = new Set(
      this.state.globalSelectedItems.length
        ? this.state.globalSelectedItems
        : selectedValues
    );

    if (!append) {
      this.state.selectListCache = [...data];
    } else {
      const existingKeys = new Set(
        this.state.selectListCache.map(item => this.getModelValue(item))
      );

      const uniqueNewItems = data.filter(
        item => !existingKeys.has(this.getModelValue(item))
      );

      this.state.selectListCache = [
        ...this.state.selectListCache,
        ...uniqueNewItems
      ];
    }

    /**
    * Ensure previously selected items stay visible in internal cache
    * (Avoid losing bindLabel when search changes)
    */
    const missingSelected = Array.from(selectedSet).filter(sel =>
      !this.state.selectListCache.some(
        item => this.getModelValue(item) === sel
      )
    );

    if (missingSelected.length) {
      const restoredItems = missingSelected.map(val =>
        this.findItemByValue(val)
      ).filter(x => x != null);

      this.state.selectListCache = [
        ...restoredItems,
        ...this.state.selectListCache
      ];
    }

    /**
    * Patch selected values back to FormControl
    */
    this.searchedselect.patchValue(
      this.enableSingleSelect
        ? (selectedValues[0] || null)
        : selectedValues,
      { emitEvent: false }
    );

    /**
    * Recalculate isSelectAllItems correctly
    */
    this.state.isSelectAllItems =
      this.state.selectListCache.length > 0 &&
      this.state.selectListCache.every(
        item => selectedSet.has(this.getModelValue(item))
      );

    /**
    * Refresh view
    */
    this.state.visibleSelectList = [...this.state.selectListCache];
    this.selectList$.next(this.state.selectListCache);
    this.state.showNotFound =
      this.state.selectListCache.length === 0 &&
      this.state.globalSelectedItems.length === 0;
  }

  // To fetch select items from the API.
  private fetchRemoteData(payload: any): Observable<any[]> {
    return this.sendAPI[this.apiNameProperty](payload).pipe(
      map((res: any) => {
        this.state.totalselectItemCount = res?.total || 0;
        const raw = (res?.data || []).filter((d: any) => d !== null && d !== undefined);
        const converted = raw.map((d: any) => this.normalizeItem(d));
        return converted;
      }),
      catchError(() => of([])),
      finalize(() => (this.state.selectLoading = false))
    );
  }

  private getLocalPaginatedData(term: string): any[] {
    const filtered = this.state.previousList.filter((item: any) =>
      this.getSearchValue(item).toLowerCase().includes(term.toLowerCase())
    );
    const start = (this.state.currentPage - 1) * this.pageSize;
    const paginated = filtered.slice(start, start + this.pageSize);
    this.state.totalselectItemCount = filtered.length;
    this.state.selectLoading = false;
    return paginated;
  }
  
  initISearchListener(): void {
    // Prevent multiple subscriptions
    if (this.selectSearchSub) return;

    this.selectSearchSub = this.selectInput$
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap(() => {
          this.state.selectLoading = true;
          this.state.currentPage = 1;
        }),
        switchMap((term: string) => this.handleSearchTerm(term))
      )
      .subscribe((data: any[]) => {
        this.updateSelectList(data, false);
      });
  }

  private handleSearchTerm(term: string): Observable<any[]> {

    const trimmed = term?.trim() || '';

    // ✅ LOCAL ONLY SEARCH (Third Party Apps)
    if (this.isLocalOnly()) {
      this.state.selectLoading = false;

      if (trimmed.length >= 3) {
        return of([...this.localData]);
      }

      return of(this.getLocalFilteredData(trimmed));
    }

    // Case 1: >= 3 characters → SEARCH
    if (trimmed.length >= 3) {

      if (!this.state.hasSearchSnapshot) {
        // take current list and status for reset at the time of search clear
        this.state.previousList = [...this.state.selectListCache];
        this.state.previousPage = this.state.currentPage;
        this.state.previousTotalCount = this.state.totalselectItemCount;
        this.state.previousFilterType = this.state.currentSelectFilterType;
        this.state.hasSearchSnapshot = true;
      }
      this.state.lastSearchTerm = trimmed;
      this.state.currentSelectFilterType = FilterType.SEARCH;
      this.state.currentPage = 1;

      // API search
      if (!this.state.isLoadAllItems) {
        const payload = this.buildPayload();
        return this.fetchRemoteData(payload);
      }

      // Local search
      return of(this.getLocalFilteredData(trimmed));
    }

    // Case 2: cleared input
    if (trimmed.length === 0) {

      this.state.currentSelectFilterType = this.state.previousFilterType;
      this.state.lastSearchTerm = '';
      this.state.currentPage = this.state.previousPage;
      this.state.totalselectItemCount = this.state.previousTotalCount;

      // restore LOAD_ALL flag correctly
      this.state.isLoadAllItems = this.state.previousFilterType === FilterType.LOAD_ALL;

      // reset snapshot
      this.state.hasSearchSnapshot = false;

      this.state.selectLoading = false;
      return of(this.state.previousList);

    }

    // Case 3: 1-2 characters typed → restore last visible list
    if (trimmed.length > 0 && trimmed.length < 3) {
      this.state.selectLoading = false;

      return of(
        this.state.hasSearchSnapshot
          ? [...this.state.previousList]
          : [...this.state.selectListCache]
      );
    }
  }

  loadAllSelectItems() {

    this.state.currentSelectFilterType = FilterType.LOAD_ALL;

    // Take snapshot ONCE if we are about to search locally
    if (this.state.lastSearchTerm && !this.state.hasSearchSnapshot) {
      this.state.previousList = [...this.state.selectListCache];
      this.state.previousPage = this.state.currentPage;
      this.state.previousTotalCount = this.state.totalselectItemCount;
      this.state.previousFilterType = FilterType.LOAD_ALL;
      this.state.hasSearchSnapshot = true;
    }

    // LOCAL load-all (already have all data)
    if (this.state.isLoadAllItems) {

      // Filter from SNAPSHOT (never from working list)
      const source = this.state.hasSearchSnapshot ? this.state.previousList : this.state.selectListCache;

      const filteredData = this.state.lastSearchTerm
        ? source.filter(item =>
            this.getSearchValue(item)
                .toLowerCase()
                .includes(this.state.lastSearchTerm.toLowerCase())
          )
        : source;

      this.updateSelectList(filteredData, false);

      // DO NOT mutate previousList here
      this.state.isSelectAllItems = false;
      this.state.isLoadAllItems = true;
      return;
    }

    //  FIRST-TIME load-all → API call
    this.state.selectLoading = true;

    const payload = this.buildPayload();
    this.fetchRemoteData(payload)
      .subscribe((data: any[]) => {
        this.updateSelectList(data, false);

        // API load-all establishes source list
        this.state.previousList = data;
        this.state.isSelectAllItems = false;
        this.state.isLoadAllItems = true;
      });
  }

  loadMoreItems() {

    if (this.state.selectLoading) return;
    // all items already loadded
    if (this.state.selectListCache.length >= this.state.totalselectItemCount) return;

    this.state.currentPage++;

    if (this.state.currentSelectFilterType === FilterType.SEARCH) {
      this.loadMoreSearch();
    } else {
      this.loadSelectItems(true);
    }
  }

  private loadMoreSearch(): void {

    this.state.selectLoading = true;

    // API based pagination
    if (!this.state.isLoadAllItems) {
      const payload = this.buildPayload(true);
      this.fetchRemoteData(payload)
          .subscribe(data => this.updateSelectList(data, true));
      return;
    }

    // Local pagination
    const paginated = this.getLocalPaginatedData(this.state.lastSearchTerm);
    this.updateSelectList(paginated, true);
  }

  onSelectBoxOpen(): void {
    // call only once
    if (!this.state.hasSelectBoxLoadedOnce) {
      this.state.hasSelectBoxLoadedOnce = true;
      if (this.hasDefaultList) {
        // Load only if there is a default list; otherwise, do not load a default list.
        this.loadSelectItems(false);
      }
    }
  }

  private normalizeItem(item: any): any {
    if (typeof item === 'string') {
      return { [this.bindValue]: item, [this.bindLabel]: item };
    }
    return item;
  }

  private getSearchValue(item: any): string {
    if (item == null) return '';
    if (typeof item === 'string') return item;
    const val = item[this.bindLabel];
    return val !== undefined && val !== null ? String(val) : '';
  }

  private getModelValue(item: any): any {
    if (item == null) return null;
    if (typeof item === 'string') return item;
    return item[this.bindValue] !== undefined ? item[this.bindValue] : item;
  }

  onClearSelection() {
    this.state.globalSelectedItems = [];
    this.state.isSelectAllItems = false;
    // remove the selected flag from UI list
    this.state.selectListCache = this.state.selectListCache.map(item => ({
      ...item,
      selected: false
    }));
    this.selectList$.next(this.state.selectListCache);
  }

  private findItemByValue(value: any): any {
    const key = this.bindValue;
    return this.state.previousList.find(item => item[key] === value)
      || this.state.selectListCache.find(item => item[key] === value)
      || { [key]: value, [this.bindLabel]: value }; // Fallback
  }

  onAnyItemRemoved() {
    this.state.isSelectAllItems = false;
  }

}
